import React from 'react'

import {
    LessonCard,
    LessonMain,
    LessonMeta,
    LessonNumber,
    LessonRoom,
    LessonSubject,
    LessonTeacher,
    WindowBadge,
} from '../../../components/scharedStyles/style'
import { formatScheduleDate } from '../utils/formatScheduleDate'
import {
    formatTeacherFromItem,
    getClassTypeName,
    getGroupName,
    getLesson,
    getRoomName,
    getSubjectName,
    isWindowLesson,
} from '../utils/lessonHelpers'

const ScheduleLessonCard = ({ item, index, viewMode }) => {
    const lesson = getLesson(item)
    const isWindow = isWindowLesson(item, lesson)
    const lessonDate = lesson?.class_date || item?.class_date || '—'

    return (
        <LessonCard $isWindow={isWindow}>
            <LessonNumber $isWindow={isWindow}>
                {lesson?.bell_id || item?.bell_id || index + 1}
            </LessonNumber>

            <LessonMain>
                <LessonSubject>
                    {isWindow ? 'Окно' : getSubjectName(item, lesson)}
                </LessonSubject>

                <LessonMeta>
                    {isWindow ? (
                        <>
                            <WindowBadge>Свободный слот</WindowBadge>
                            <span>
                                <b>Дата:</b> {formatScheduleDate(lessonDate)}
                            </span>
                        </>
                    ) : (
                        <>
                            <span>
                                <b>Тип:</b> {getClassTypeName(item, lesson)}
                            </span>
                            <span>
                                <b>Дата:</b> {formatScheduleDate(lessonDate)}
                            </span>
                        </>
                    )}
                </LessonMeta>
            </LessonMain>

            {!isWindow && (
                <>
                    <LessonTeacher>
                        {viewMode === 'teacher'
                            ? getGroupName(item, lesson)
                            : formatTeacherFromItem(item, lesson)}
                    </LessonTeacher>
                    <LessonRoom>{getRoomName(item, lesson)}</LessonRoom>
                </>
            )}
        </LessonCard>
    )
}

export default ScheduleLessonCard
